'use client'

import { logCustomEvent } from '@/shared/firebase'
import React, { useEffect } from 'react'

export function FirebaseProvider({ children }: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    logCustomEvent('page_view')
  }, [])

  return (
    <>
      {children}
    </>
  )
}
